import axios from "axios";
import {PaginateModel,} from "../../models/PaginateModel";
import {IMPORT_REQUEST_ENDPOINT, WAREHOUSE_LOG_ENDPOINT} from "../../constants/endpoints";
import {ISearch} from "../../models/WareHouseModel";
import { WareHouseModel } from "../../models/WarehouseReportModel";

export interface WareHouseLogListModel {
  paginate_data: PaginateModel<WareHouseModel>,
  summary: {
    total_consign_qty: number,
    total_sales_amount: number,
    total_warehouse_amount: number,
    total_debt: number
  }
}

export function getReportList(params?: ISearch) {
  return axios.get<WareHouseLogListModel>(`${IMPORT_REQUEST_ENDPOINT}/get-report`, {params})
}

export function exportReport(params?: ISearch) {
  return axios.get<Blob>(`${IMPORT_REQUEST_ENDPOINT}/export-report`, {
    responseType: 'blob',
    params,
  }) 
}
